var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-auto"})
}
var staticRenderFns = []

export { render, staticRenderFns }